import axios from 'axios';
import toastr from 'toastr';
import moment from 'moment';

import * as actions from './actionsTypes';
import messages from "../../messages";
import CalendarEmployeeServices from './calendar.services';
import { eventTypes } from '../../../pages/vacations/calendar/eventTypes';

const formatEmployeeCalendarEvent = (event) => {
  return {
    id: event.id,
    start: event.fecha_inicio,
    end: moment(event.fecha_fin).add(1, "day").format("YYYY-MM-DD"),
    horas: event.horas,
    title: event.titulo,
    color: event.tipo === eventTypes.vacaciones.name ? eventTypes.vacaciones.color : event.tipo === eventTypes.tiempoCompensatorio.name ? eventTypes.tiempoCompensatorio.color : eventTypes.horasExtra.color,
    extendedProps: {
      type: event.tipo,
      notes: event.comentario,
      location: event.lugar
    }
  }
}

export const getEmployeeCalendarEvents = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.IS_LOADING_EMPLOYEE_CALENDAR_EVENTS,
      payload: true,
    });
    const resp = await Promise.all([CalendarEmployeeServices.getCalendarUserEvents(filters), CalendarEmployeeServices.getCalendarHolidays()]);
    const [events, holidays] = resp;
    let eventsData = [];
    
    const { eventos: usersEvents, datos_empleado: userData, indicadores: kpiEvents, indicadores_tiempos_compensatorios: kpiEventsCompensatoryTimes } = events.data.data;

    usersEvents.forEach(event => {
      eventsData = [...eventsData, formatEmployeeCalendarEvent(event)];
    });
    holidays.data.data.forEach(holiday => {
      eventsData = [...eventsData,{
        start: holiday.fecha_inicio,
        end: moment(holiday.fecha_fin).add(1, "day").format("YYYY-MM-DD"),
        display: 'background',
        backgroundColor: eventTypes.feriados.color,
        borderColor: eventTypes.feriados.color,
        extendedProps: {
          type: 'feriado',
        }
      }];
    });
    dispatch({
      type: actions.GET_EMPLOYEE_CALENDAR_EVENTS,
      payload: {userData, kpiEvents: kpiEvents, eventsData, kpiEventsCompensatoryTimes}
    });
    dispatch({
      type: actions.FAIL_EMPLOYEE_CALENDAR_EVENTS,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 401:
            window.location.href = "/";
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.FAIL_EMPLOYEE_CALENDAR_EVENTS,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.IS_LOADING_EMPLOYEE_CALENDAR_EVENTS,
      payload: false,
    });
  }

};

export const getEmployeeCalendarEvent = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.IS_LOADING_EMPLOYEE_CALENDAR_EVENT,
      payload: true,
    });
    const resp = await CalendarEmployeeServices.getCalendarUserEvent(id);
    dispatch({
      type: actions.GET_EMPLOYEE_CALENDAR_EVENT,
      payload: formatEmployeeCalendarEvent(resp.data),
    });
    dispatch({
      type: actions.FAIL_EMPLOYEE_CALENDAR_EVENT,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 401:
            window.location.href = "/";
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.FAIL_EMPLOYEE_CALENDAR_EVENT,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.IS_LOADING_EMPLOYEE_CALENDAR_EVENT,
      payload: false,
    });
  }
}

export const saveEmployeeCalendarEvent = (data, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.IS_SAVE_EMPLOYEE_CALENDAR_EVENT,
      payload: true,
    });
    const resp = await CalendarEmployeeServices.createCalendarUserEvent(data);
    const { calendarEmployeeEvents } = getState().calendarEmployeeEvents;
    let _calendarEmployeeEvents = calendarEmployeeEvents.eventsData
    const {Event: userEvent, indicadores: kpiEvents, indicadores_tiempos_compensatorios: kpiEventsCompensatoryTimes} = resp.data;
    _calendarEmployeeEvents = [..._calendarEmployeeEvents, formatEmployeeCalendarEvent(userEvent)];
    //_calendarEmployeeEvents.count += 1;
    dispatch({
      type: actions.GET_EMPLOYEE_CALENDAR_EVENTS,
      payload: { ...calendarEmployeeEvents, eventsData: _calendarEmployeeEvents, kpiEvents: kpiEvents, kpiEventsCompensatoryTimes },
    });
    dispatch({
      type: actions.FAIL_SAVE_EMPLOYEE_CALENDAR_EVENT,
      payload: "",
    });
    setShowModal(false);
    toastr.success(messages.successMessage);
  } catch (ex) {
    console.error(ex);
    console.log(ex);
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data;
            break;
          case 401:
            window.location.href = "/";
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.FAIL_SAVE_EMPLOYEE_CALENDAR_EVENT,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.IS_SAVE_EMPLOYEE_CALENDAR_EVENT,
      payload: false,
    });
  }
}

export const updateEmployeeCalendarEvent = (id, data, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.IS_SAVE_EMPLOYEE_CALENDAR_EVENT,
      payload: true,
    });

    const resp = await CalendarEmployeeServices.updateCalendarUserEvent(id, data);

    // Obtener el estado actual de los eventos
    const { calendarEmployeeEvents } = getState().calendarEmployeeEvents;

    // Buscar el evento correcto por ID
    const _calendarEmployeeEvents = calendarEmployeeEvents.eventsData.slice();
    const eventIndex = _calendarEmployeeEvents.findIndex(event => event.id === parseInt(id));
    const {Event: userEvent, indicadores: kpiEvents, indicadores_tiempos_compensatorios: kpiEventsCompensatoryTimes} = resp.data;
    
    if (eventIndex !== -1) {
      // Actualizar el evento encontrado
      _calendarEmployeeEvents[eventIndex] = formatEmployeeCalendarEvent(userEvent);

      dispatch({
        type: actions.GET_EMPLOYEE_CALENDAR_EVENTS,
        payload: { ...calendarEmployeeEvents, eventsData: _calendarEmployeeEvents, kpiEvents: kpiEvents, kpiEventsCompensatoryTimes },
      });
    }

    dispatch({
      type: actions.FAIL_SAVE_EMPLOYEE_CALENDAR_EVENT,
      payload: "",
    });
    if(setShowModal){
      setShowModal(false);
    }
    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data;
            break;
          case 401:
            window.location.href = "/";
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.FAIL_SAVE_EMPLOYEE_CALENDAR_EVENT,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.IS_SAVE_EMPLOYEE_CALENDAR_EVENT,
      payload: false,
    });
  }
};


export const deleteEmployeeCalendarEvent = (id, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.IS_LOADING_EMPLOYEE_CALENDAR_EVENTS,
      payload: true,
    });
    const resp = await CalendarEmployeeServices.deleteCalendarUserEvent(id);
    const { calendarEmployeeEvents } = getState().calendarEmployeeEvents;
    const _calendarEmployeeEvents = calendarEmployeeEvents.eventsData.slice();
    const eventIndex = _calendarEmployeeEvents.findIndex(event => event.id === id);
    const {indicadores: kpiEvents, indicadores_tiempos_compensatorios: kpiEventsCompensatoryTimes} = resp.data;

    if (eventIndex !== -1) {
      _calendarEmployeeEvents.splice(eventIndex, 1);
      dispatch({
        type: actions.GET_EMPLOYEE_CALENDAR_EVENTS,
        payload: { ...calendarEmployeeEvents, eventsData: _calendarEmployeeEvents, kpiEvents: kpiEvents, kpiEventsCompensatoryTimes },
      });
      toastr.success(messages.successMessage);
    }    
    
    dispatch({
      type: actions.FAIL_EMPLOYEE_CALENDAR_EVENTS,
      payload: "",
    });
    setShowModal(false);
    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data;
            break;
          case 401:
            window.location.href = "/";
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.FAIL_EMPLOYEE_CALENDAR_EVENTS,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.IS_LOADING_EMPLOYEE_CALENDAR_EVENTS,
      payload: false,
    });
  }
}